import { Typography } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import ConfirmationModal from 'components/new-ui/composed/modal/confirmation-modal/ConfirmationModal';

type Props = {
    open: boolean;
    productCount: number;
    loading?: boolean;
    onCancel: () => void;
    onConfirm: () => void;
};

const DeleteProductsModal = ({ open, productCount, loading = false, onCancel, onConfirm }: Props) => {
    const isSingle = productCount === 1;
    const title = isSingle ? 'Delete item?' : `Delete ${productCount} items?`;
    const message = isSingle
        ? 'The item will be removed from the declaration.'
        : 'The selected items will be removed from the declaration.';

    return (
        <ConfirmationModal
            width={500}
            type="error"
            title={title}
            confirmButtonText="Delete"
            confirmationButtonLoading={loading}
            icon={<DeleteOutlined />}
            content={<Typography.Text>{message}</Typography.Text>}
            open={open}
            onCancel={onCancel}
            onConfirm={onConfirm}
        />
    );
};

export default DeleteProductsModal;
